import { useSubjectMember } from '@healthblocks-io/core'
import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Grid } from '@/@bothrs-ui/web/components/layout/grid/Grid'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H1 } from '@/@bothrs-ui/web/components/typography/Heading'
import { globalDefinitions } from '@/defined-translations'
import { FloatingLayoutBox } from '@/layout/components/floating-layout/FloatingLayout.styled'
import { ContactInformationForm } from '@/modules/profile/components/contact-information-form/ContactInformationForm'
import { getDropInProps } from '@/modules/shared/animations/dropIn.animation'
import { KeyValue } from '@/modules/shared/components/key-value'
import { formatLocale } from '@/modules/shared/helpers/locale'

export const InformationBox = ({ onContactInformationComplete }: { onContactInformationComplete: () => void }) => {
  const subject = useSubjectMember()
  const theme = useTheme()
  const textColor = theme.Colors.Neutrals.Darkest

  return (
    <FloatingLayoutBox key='personal-contact-information-form' {...getDropInProps()}>
      <H1 color={textColor}>
        {t({
          id: 'onboarding.personal-contact-information.title',
          message: 'Contactinfo voor het ziekenhuis',
        })}
      </H1>
      <P type='BodyLargeRegular' color={textColor}>
        {t({
          id: 'onboarding.personal-contact-information.body',
          message: 'We haalden even je gegevens op via e-health. Kijk ze goed na en pas aan waar nodig.',
        })}
      </P>

      <Grid
        gridTemplateColumns='repeat(2, 1fr)'
        gridTemplateRows='repeat(2, 1fr)'
        rowGap={theme.UI.Spacing.Space6}
        columnGap={theme.UI.Spacing.Space6}
      >
        <FlexColumn gap={theme.UI.Spacing.Space2}>
          <KeyValue label={i18n._(globalDefinitions.labelName)} value={subject?.name ?? 'Onbekend'} />
        </FlexColumn>

        <FlexColumn gap={theme.UI.Spacing.Space2}>
          <KeyValue label='Rijksregisternummer' value={subject?.nationalId ?? 'Onbekend'} />
        </FlexColumn>

        <FlexColumn gap={theme.UI.Spacing.Space2}>
          <KeyValue
            label={i18n._(globalDefinitions.labelDateOfBirth)}
            value={subject?.birthDate ? formatLocale(subject?.birthDate, 'dd/MM/yyyy') : 'Onbekend'}
          />
        </FlexColumn>

        <FlexColumn gap={theme.UI.Spacing.Space2}>
          <KeyValue
            label={i18n._(globalDefinitions.gender)}
            value={
              subject?.gender
                ? i18n._(globalDefinitions[`gender${subject.gender}` as keyof typeof globalDefinitions] as string)
                : i18n._(globalDefinitions.genderU)
            }
          />
        </FlexColumn>
      </Grid>

      <Margin mt={theme.UI.Spacing.Space10}>
        <ContactInformationForm
          onComplete={onContactInformationComplete}
          actionLabel='Dit is correct'
          onBoarding={true}
        />
      </Margin>
    </FloatingLayoutBox>
  )
}
